import Header from '@/components/header/index.vue'
import Drawitem from '@/components/drawitem/index.vue'
import Buyitem from '@/components/buyitem/index.vue'
import Item from '@/components/item/index.vue'
import Gems from '@/components/gems/index.vue'
import History from '@/components/history/index.vue'
import Alert from '@/components/alert/index.vue'
import EuPolicyAlert from '@/components/base/EuPolicyAlert.vue'

import { getSessionStorage, initGA, addGA, errorGA, timeout } from '@/utils/assist'
import { euData, euPopupInject } from '@/utils/eu_popup'

export default {
  name: 'home',
  data () {
    return {
      globalConfig: this.$bus.$data,
      rule: '',
      buypool: [],
      drawpool: [],
      currentItem: [],
      showSecConfirm: false,
      showReedeem: false,
      showRule: false,
      showHistory: false,
      showDrawTip: false,
      history: [],
      wantBuy: {},
      alreadyBuyTimes: 0,
      availableDrawPool: [],
      currentItemIndex: [], // 高亮的item
      drawnItemIndex: -1, // 抽中的item,
      rollingPool: [],
      forceStop: true,
      tipMsg: '',
      showNameIndex: '',
      drawLoading: false, // 抽奖中
      alertShow: false,
      alertTitle: '',
      alertContent: '',
      ...euData
    }
  },
  components: {
    Header,
    Drawitem,
    Buyitem,
    Item,
    Gems,
    History,
    Alert,
    EuPolicyAlert
  },
  computed: {
    transify () {
      return this.$bus.$data.transify
    }
  },
  methods: {
    initInfo () {
      let accessToken = getSessionStorage(`${PROJECT_NAME}AccessToken`) || ''
      let lang = getSessionStorage(`${PROJECT_NAME}Lang`) || ''
      if (!accessToken) return this.$bus.handleError('TOAST_LOGIN_FAILED')
      this.$api
        .info({
          access_token: accessToken,
          lang: lang
        })
        .then(response => {
          // NOTE error state has been already handled in request.js
          // TODO 成功后处理并缓存数据
          let data = response.data
          let data_log_name = data.data_log_name
          Object.assign(this.$bus.$data, data)
          this.googleAnalyticsPopupInject(data)
          if (data['policy_popup']) {
            const {
              popup_title: policyTitle,
              popup_content: policyCtx,
              checked: policyHide
            } = data['policy_popup']
            this.alertShow = !policyHide
            this.alertTitle = policyTitle
            this.alertContent = policyCtx
          }
          this.rule = data.rule
          this.buypool = data.event_config.buy_pool
          this.drawpool = data.event_config.draw_pool
          this.initBuyPool()
          document.body.setAttribute('data-lang', data.common_config.lang)
          initGA(data.common_config.region, this.$bus.uid, data_log_name)
        })
        .catch(error => {
          // NOTE error has been already handled in request.js
          console.log(error, 'initInfo...')
        })
    },
    chooseItem (item, index, type) {
      let pool = type == 'buy' ? 'buypool' : 'drawpool'
      this[pool][index].showName = true
      this.showNameIndex = index
      timeout(() => {
        this.$set(this[pool], index, Object.assign({}, this[pool][index], { 'showName': false }))
      }, 1500)

      if (pool == 'buypool') {
        if (item.drawn) return
        if (this.wantBuy.pk == item.pk) {
          this.wantBuy = {}
          return addGA('chooseBuyItem', 'cancel')
        }
        this.wantBuy = item
        this.wantBuy.index = index
        addGA('chooseBuyItem', 'confirm')
      } else {
        addGA('clickDrawItem', 'confirm')
      }
    },
    secConfirm () {
      addGA('purchase', 'confirm')
      if (this.wantBuy.gems > this.globalConfig.player.gems) {
        this.$toast(this.transify.TOAST_GEM_NOT_ENOUGH)
        return
      }
      if (this.isAllBuy() === true) return
      if (Object.keys(this.wantBuy).length < 1) {
        this.$toast(this.transify.BUY_SELECT_TIP)
      } else {
        this.currentItem = []
        this.currentItem.push(this.wantBuy)
        this.tipMsg = this.wantBuy.is_token ? this.transify.UNIQUE_BUY_ALREADY_HAVE : this.transify.COMMON_TIPS_ITEM
        this.showSecConfirm = true
      }
    },
    initBuyPool () {
      let i = 0
      this.buypool.map((item, index) => {
        if (item.drawn) {
          i++
        }
      })
      this.alreadyBuyTimes = i
    },
    updateBuyPool (index) {
      this.alreadyBuyTimes++
      this.buypool[index].drawn = 1
    },
    updateRollingPool () {
      this.rollingPool = this.drawpool
        .map((item, index) => (item.drawn ? null : index))
        .filter(item => item !== null)
    },
    formatStr (str) {
      let arr = str && str.split('\n')
      let newStr = ''
      for (let i in arr) {
        newStr += '<p>' + arr[i] + '</p>'
      }
      return newStr
    },
    purchase () {
      let data = { 'id': this.wantBuy.pk, 'gems': this.wantBuy.gems }
      let index = this.wantBuy.index
      this.$api
        .purchase(data)
        .then(response => {
          let result = response.data.ids
          const isToken = response.data.is_token
          this.showSecConfirm = false
          new Promise(resolve => {
            this.showDrawTip = true
            timeout(() => {
              this.showDrawTip = false
              resolve(result)
            }, 1500)
          }).then((result) => {
            this.draw(result, isToken)
          })

          this.$bus.$data.player.gems -= this.wantBuy.gems
          this.wantBuy = {}
          this.updateBuyPool(index)
          addGA('purchase', 'success')
        })
        .catch(error => {
          this.showSecConfirm = false
        })
    },
    // 获取index
    getIndexByPk (pk, pool) {
      let index = -1
      let items = []
      pk.forEach(i => {
        pool.filter((item, index) => {
          if (item.pk === i && !item.drawn) {
            items.push(index)
          }
        })
      })
      return items.length == pk.length ? items : false
    },
    drawing () {
      this.resetDraw()
      this.forceStop = false
      this.drawLoading = true
      this.updateRollingPool()
      let i = 0
      let delayTime = 100
      let len = this.rollingPool.length
      this.timer = setInterval(() => {
        this.currentItemIndex = []
        this.currentItemIndex.push(this.rollingPool[i])
        if (this.currentItemIndex.indexOf(this.drawnItemIndex) > -1 || this.forceStop) {
          clearInterval(this.timer)
        }
        i >= len - 1 ? (i = 0) : i++
      }, delayTime)
      return new Promise(resolve => {
        timeout(() => {
          resolve()
        }, 2000) // 2s动画后
      })
    },
    /* 停止抽奖
     * @param {index} 抽中的元素index
     * @param {time} 停留时间
     */
    stopDrawing (index, time) {
      return new Promise(resolve => {
        this.drawnItemIndex = index
        timeout(() => {
          this.resetDraw()
          resolve()
        }, time)
      })
    },
    // 重置抽奖
    resetDraw () {
      clearInterval(this.timer)
      this.drawnItemIndex = -1
      this.currentItemIndex = []
    },
    verifyRes (res) {
      let result = this.getIndexByPk(res, this.drawpool)
      if (!result) {
        this.forceStop = true
        this.$message(this.transify.TOAST_NETWORK_ERROR)
        this.drawLoading = false
        return false
      }
      return result
    },
    draw (result, isToken) {
      this.currentItem = []
      // 最后一次购买
      if (this.alreadyBuyTimes >= this.buypool.length) {
        result = this.verifyRes(result)
        if (!result) return
        result.map((item, index) => {
          this.currentItem.push(this.drawpool[item])
          this.currentItemIndex.push(item)
        })
        this.tipMsg = isToken ? this.transify.UNIQUE_BUY_ALREADY_HAVE_PART : this.transify.COMMON_TIPS_ITEM
        timeout(() => {
          result.map((item) => {
            this.drawpool[item].drawn = 1
          })
          this.showReedeem = true
          this.drawLoading = false
          this.resetDraw()
        }, 1500)
        addGA('draw', 'success')
      } else {
        // 先执行动画
        this.drawing().then(() => {
          result = this.verifyRes(result)
          if (!result) return
          // 动画停止
          this.stopDrawing(result[0], 1500).then(() => {
            this.drawpool[result[0]].drawn = 1
            this.currentItem.push(this.drawpool[result[0]])
            // 二抽
            this.drawing().then(() => {
              this.stopDrawing(result[1], 1000).then(() => {
                this.drawpool[result[1]].drawn = 1
                this.currentItem.push(this.drawpool[result[1]])
                this.tipMsg = isToken ? this.transify.UNIQUE_BUY_ALREADY_HAVE_PART : this.transify.COMMON_TIPS_ITEM
                this.showReedeem = true
                this.drawLoading = false
                addGA('draw', 'success')
              })
            })
          })
        })
      }
    },

    isAllBuy () {
      this.showReedeem = false
      if (this.alreadyBuyTimes >= this.buypool.length) {
        this.$toast(this.transify.BUY_ALL_TIP)
        return true
      }
    },
    checkHistory () {
      addGA('showHistory', 'click')
      this.$api
        .history()
        .then(response => {
          let data = response.data
          this.history = data
          this.showHistory = true
          addGA('showHistory', 'success')
        })
    },
    checkRule () {
      this.showRule = true
      addGA('showRule', 'success')
    },
    googleAnalyticsPopupInject: euPopupInject
  },
  mounted () {
    this.initInfo()
  }
}



// WEBPACK FOOTER //
// ./src/views/home/home.js